import React, { ReactElement, useEffect } from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Operations from '../../../operations'
import { IncidentReport } from '../../../components/reports'
import { sizes } from '@lmc/common/constants'

type Props = {
  data: any
  error?: string
  fetchData: () => void
  isLoading?: boolean
  testId?: string
}

export function IncidentsReportScreen({
  isLoading,
  error,
  data,
  fetchData,
  testId = 'incidents-report-screen'
}: Props): ReactElement {
  useEffect(() => {
    fetchData()
  }, [])

  return (
    <div style={styles.mainContainer} data-testid={testId}>
      <IncidentReport
        data-testid={`${testId}-chart`}
        chartHeight={400}
        data={data}
        error={error}
        isLoading={isLoading}
        title="Incidents per month"
        backLink={undefined}
        emptyText={undefined}
      />
    </div>
  )
}

const STATE_ID = 'reports_incidents'

const styles = {
  mainContainer: {
    maxWidth: sizes.childScreen,
    margin: '0 auto',
    padding: '24px 24px'
  }
}

IncidentsReportScreen.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool
}

const mapStateToProps = (state: any) => ({
  isLoading: _.get(state, `data.requests.${STATE_ID}.isLoading`),
  error: _.get(state, `data.requests.${STATE_ID}.error`),
  data: _.get(state, `data.requests.${STATE_ID}.response`),
  userRole: state.global.user.role
})

const mapDispatchToProps = (dispatch: any) => ({
  fetchData: () => {
    dispatch(
      Operations.fetchData({
        url: 'aggregations/incidents',
        id: STATE_ID
      })
    )
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(IncidentsReportScreen)
